/*
 * @Description: 文件描述
 */
import formatTime from '@/utils/date'

// 获取表格数据前的query搜索参数
function getFilterParams() {
  try {
    const filterForm = this.getFilter()
    const [ createTimeFrom, createTimeTo ] = filterForm.startAndEnd || []
    const params = {
      ...filterForm,
      ...this.pagination,
      createTimeFrom: formatTime(createTimeFrom),
      createTimeTo: formatTime(createTimeTo),
      startAndEnd: undefined,
      pageNumber: this.pagination.current,
      total: undefined
    }
    return params
  } catch (error) {
    console.log(error)
    return {}
  }
}

export {
  getFilterParams
}
